export const MOBILE_MENU_OPEN = 'MOBILE_MENU_OPEN';
export const MOBILE_MENU_CLOSE = 'MOBILE_MENU_CLOSE';
export const MOBILE_USERMENU_OPEN = 'MOBILE_USERMENU_OPEN';
export const MOBILE_USERMENU_CLOSE = 'MOBILE_USERMENU_CLOSE';